import type { Prontuario } from "@/api/db/medico";
import { MedicoLabels } from "@/lib/labels/medico";

import { EvidenceLink } from "./evidence-link";

export function RedFlags({
	flags,
	onOpenEvidence,
}: {
	flags: Prontuario["redFlags"];
	onOpenEvidence?: (evidence: string) => void;
}) {
	if (flags.length === 0) {
		return null;
	}

	return (
		<div className="flex flex-col gap-2">
			{flags.map((flag) => (
				<div
					key={flag.rule}
					className="rounded-md border border-destructive/30 bg-destructive/10 px-3 py-2"
				>
					<div className="flex items-start justify-between gap-2">
						<div className="flex flex-col gap-1">
							<p className="text-xs text-foreground">{MedicoLabels.redFlag[flag.rule]}</p>

							{!!flag.gaps.length && (
								<div className="flex flex-wrap gap-1.5 text-xs text-muted-foreground">
									{flag.gaps.map((gap) => (
										<span key={gap}>{MedicoLabels.relance[gap] ?? gap}</span>
									))}
								</div>
							)}
						</div>

						<EvidenceLink evidence={flag.evidence} onOpen={onOpenEvidence} />
					</div>
				</div>
			))}
		</div>
	);
}
